import { cosemApi } from '@services/providers/cosem';
import { ApiResponse } from '@services/providers/cosem.types';
import { NewsCategory } from './news-categories.types';

const newsCategoriesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getNewsCategories: build.mutation<ApiResponse<NewsCategory[]>, void>({
            query: () => {
                return {
                    url: `/product/news-categories`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<NewsCategory[]>) => response
        })
    })
});

export const { useGetNewsCategoriesMutation } = newsCategoriesApi;
